<template>
  <bc-modal
    header="Cart"
    variant="drawer"
    v-model="cart"
  >
    <div>
        <ul v-if="cartCount > 0" role="list" class="divide-y divide-gray-200 dark:divide-gray-800">
          <li v-for="item in cartProducts" :key="item.sku" class="p-6 flex items-start">
            <div class="flex-1 flex flex-col">
              <div>
                <div class="flex justify-between text-base font-medium">
                  <h3 class="font-bold">
                    {{ item.title }}
                  </h3>
                  <p class="ml-4 font-bold">
                    £{{ item.price }}
                  </p>
                </div>
                <!--div>&times; {{ item.quantity }}</div-->
                <div v-if="item.option">
                  <p>
                    <span class="text-gray-500">Location:</span> {{ item.option.location ? item.option.location.city : 'Online'}}
                  </p>
                  <p>
                    <span class="text-gray-500">Date:</span> {{ item.option.start_date | moment("MMM Do YYYY") }}
                  </p>

                </div>
              </div>
              <div class="flex-1 flex items-end justify-between text-sm">
                <div class="flex">
                  <button type="button" class="font-medium text-primary-600 hover:text-primary-500" @click="removeFromCart(item)">Remove</button>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <div v-else class="px-4 sm:px-6 lg:px-8 text-center">
          <p class="my-6">
            You have no items in your shopping cart.
          </p>
        </div>
    </div>


      <template v-slot:footer>
        <div class="w-full" v-if="cartCount > 0">
          <div class="flex justify-between text-base font-medium">
            <p>Total</p>
            <p>£{{ cartSubTotal }}</p>
          </div>
          <div class="mt-4 flex w-full">
            <bc-button variant="primary" class="w-full justify-center" href="/checkout">Checkout</bc-button>
          </div>
          <div class="mt-4 flex justify-center text-xs text-center text-gray-500">
              <p>Prices inclusive of VAT.</p>
          </div>
          <div class="mt-4 flex justify-center text-sm text-center text-gray-500">
            <p>
              or <a href="/" class="text-primary-600 font-medium hover:text-primary-500">Continue Shopping<span aria-hidden="true"> &rarr;</span></a>
            </p>
          </div>
        </div>
      </template>
  </bc-modal>

</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AppCart',
  computed: {
    cart: {
      get () {
        return this.$store.state.cart.open
      },
      set (val) {
        this.$store.commit('cart/TOGGLE', val)
      }
    },
    ...mapGetters('cart', ['cartCount', 'cartProducts', 'cartSubTotal'])
  },
  /*
  watch: {
    cart(v) {
      v === true
      ? this.$locomotive.stop()
      : this.$locomotive.start()
    }
  },
  */
  methods: {
    addOneToCart (item) {
      this.$store.dispatch('cart/addOneToCart', item)
    },
    removeOneFromCart (item) {
      this.$store.dispatch('cart/removeOne', item)
    },
    removeFromCart (item) {
      this.$store.dispatch('cart/remove', item)
    }
  }
}
</script>
